module.exports = __webpack_public_path__ + "media/סוכר.470a73fb.mp3";